import {getUserData} from "./Utils";

import axios from "axios";

export function isStudentUser() {
    return getUserData() && getUserData().userData && getUserData().userData.role.includes("user");
}

export function isRecreationAdmin() {
    return getUserData() && getUserData().userData && getUserData().userData.role.includes("recreations admin");
}

export function isTrener() {
    return getUserData() && getUserData().userData && getUserData().userData.role.includes("trener");
}

export function isSuperAdmin() {
    return getUserData() && getUserData().userData && getUserData().userData.role.includes("super admin");
}

export function isSuperAdminOrAdmin() {
    return getUserData() && getUserData().userData && (getUserData().userData.role.includes("super admin") || getUserData().userData.role.includes("admin"));
}


export function isAdminOrDelegate() {
    return getUserData() && getUserData().userData && (getUserData().userData.role.includes("admin") || getUserData().userData.role.includes("delegate"));
}

export function isDelegateOnly() {
    // eslint-disable-next-line no-use-before-define
    let userDataExtracted = getUserData() ? getUserData().userData : null;
    if (!userDataExtracted) {
        return false;
    }
    let notAdminInThisOrganisation = !userDataExtracted.role.includes("admin") ||
            // eslint-disable-next-line no-use-before-define
            (getCurrentOrganisationObject() && getCurrentOrganisationObject().name && !userDataExtracted.adminOrganisations.includes(getCurrentOrganisationObject().name))

    return notAdminInThisOrganisation && userDataExtracted.role.includes("delegate") && !userDataExtracted.role.includes("team admin");
}

export function groupsThatCanSeeCompetitionGames() {
    if (!getUserData()) {
        return false;
    }
    let canSee = false;
    getUserData().userData.role.map((singleRole) => {
        if (["super admin", "admin", "delegate", "operative"].includes(singleRole)) {
            canSee = true
        }
    })

    return canSee
}

export function isSuperAdminOrTechnician() {
    return getUserData() && getUserData().userData && (getUserData().userData.role.includes("super admin") || getUserData().userData.role.includes("technician"));
}

export function isAdmin() {
    let hasAdminRole = getUserData() && getUserData().userData && getUserData().userData.role.includes("admin");
    if (!hasAdminRole) {
        return false;
    }
    // eslint-disable-next-line no-use-before-define
    let currentOrganisationName = getCurrentOrganisationObject() ? getCurrentOrganisationObject().name : null;
    if (!currentOrganisationName) {
        return false;
    }
    let isAdminToThisOrganistion = false;
    if (getUserData().userData && getUserData().userData.adminOrganisations && getUserData().userData.adminOrganisations.map) {
        getUserData().userData.adminOrganisations.map((oneOrganisation) => {
            if (oneOrganisation === currentOrganisationName || oneOrganisation.name === currentOrganisationName) {
                isAdminToThisOrganistion = true;
            }
        })
    }
    return isAdminToThisOrganistion;

}

export function isDelegate() {
    return getUserData() && getUserData().userData && getUserData().userData.role.includes("delegate");
}

export function isOperative() {
    return getUserData() && getUserData().userData && getUserData().userData.role.includes("operative");
}

export function isTeamAdmin() {
    let hasTeamAdminRole = getUserData() && getUserData().userData && getUserData().userData.role.includes("team admin");
    if (!hasTeamAdminRole) {
        return false;
    }

    // eslint-disable-next-line no-use-before-define
    let currentOrganisationName = getCurrentOrganisationObject() ? getCurrentOrganisationObject().name : null;
    if (!currentOrganisationName) {
        return true;
    }
    let isAdminToThisOrganistion = false;
    if (getUserData().userData && getUserData().userData.adminOrganisations && getUserData().userData.adminOrganisations.map) {
        getUserData().userData.adminOrganisations.map((oneOrganisation) => {
            if (oneOrganisation === currentOrganisationName || oneOrganisation.name === currentOrganisationName) {
                isAdminToThisOrganistion = true;
            }
        })
    }
    // eslint-disable-next-line no-use-before-define
    return !isAdminToThisOrganistion && getUserData().userData.teamAdminConstituents && getUserData().userData.teamAdminConstituents.includes(getTeamAdminSastavnicaId());
}

export function isTeamLeader() {
    let isTeamLeader = getUserData() && getUserData().userData && getUserData().userData.role.includes("team leader");
    if (!isTeamLeader) {
        return false;
    }
    // eslint-disable-next-line no-use-before-define
    let currentOrganisationName = getCurrentOrganisationObject() ? getCurrentOrganisationObject().name : null;
    if (!currentOrganisationName) {
        return true;
    }
    let isAdminToThisOrganistion = false;
    if (getUserData().userData && getUserData().userData.adminOrganisations && getUserData().userData.adminOrganisations.map) {
        getUserData().userData.adminOrganisations.map((oneOrganisation) => {
            if (oneOrganisation === currentOrganisationName || oneOrganisation.name === currentOrganisationName) {
                isAdminToThisOrganistion = true;
            }
        })
    }
    // eslint-disable-next-line no-use-before-define
    return !isAdminToThisOrganistion && getUserData().userData.teamLeaderConstituents && getUserData().userData.teamLeaderConstituents.includes(getTeamAdminSastavnicaId());
}

export function isCMSAdmin() {
    return getUserData() && getUserData().userData && getUserData().userData.role.includes("CMS admin");
}

export function isCMSEditor() {
    return getUserData() && getUserData().userData && getUserData().userData.role.includes("CMS editor");
}

export function isCMSAuthor() {
    return getUserData() && getUserData().userData && getUserData().userData.role.includes("CMS author");
}

export function getFullUserName() {
    if (!getUserData()) {
        return "";
    }
    return getUserData().userData.name + " " + getUserData().userData.surname;
}

export function getUserConstituent() {
    return new Promise((resolve) => {
        let url = `${process.env.REACT_APP_MAIN_URL}/admin/constituents`;
        // eslint-disable-next-line no-use-before-define
        let organisation = getCurrentOrganisationName();
        url += `?org=${organisation}&withoutTeams=true`
        axios.get(url).then((result) => {
            result.data.constituents.map((constituent) => {
                // eslint-disable-next-line no-use-before-define
                if (constituent._id === getTeamAdminSastavnicaId()) {
                    resolve(constituent)
                }
            });
        })
    })
}

export function getTeamAdminSastavnicaId() {
    let user = getUserData() ? getUserData().userData : null;
    if (!user) {
        return null;
    }
    if (!user.role.includes("team admin") && !user.role.includes("team leader")) {
        return (user.constituent ? user.constituent : null);
    }
    let roleLocalStorage = window.localStorage.getItem('teamAdminSastavnica');
    if (!roleLocalStorage) {
        return user.constituent;
    }
    let roleParsed = JSON.parse(roleLocalStorage)
    if (roleParsed.userId === user._id && roleParsed.constituentId) {
        return roleParsed.constituentId;
    }
    return user.constituent;
}


export function getCurrentOrganisationName() {
    let user = getUserData() ? getUserData().userData : null;
    if (!user || user.rights == null || user.rights.length == 0) {
        return null;
    }
    let roleLocalStorage = window.localStorage.getItem('organizacija');
    if (!roleLocalStorage) {
        return user.rights[0].name;
    }
    let roleParsed = JSON.parse(roleLocalStorage)
    if (roleParsed.userId === user._id && roleParsed.organisation) {
        return roleParsed.organisation.name;
    }
    return user.rights[0].name;
}

export function getCurrentOrganisationObject() {
    let user = getUserData() ? getUserData().userData : null;
    if (!user || user.rights == null || user.rights.length == 0) {
        return null;
    }
    let roleLocalStorage = window.localStorage.getItem('organizacija');
    if (!roleLocalStorage) {
        return user.rights[0];
    }
    let roleParsed = JSON.parse(roleLocalStorage)
    if (roleParsed.userId === user._id && roleParsed.organisation) {
        return roleParsed.organisation;
    }
    return user.rights[0];
}

export function isRouteAllowedForUser(roles) {
    if (!getUserData() || !getUserData().userData || !getUserData().userData.role || !Array.isArray(getUserData().userData.role)) {
        return false;
    }
    if (!roles) {
        return false;
    }
    let isAllowed = false;
    roles.map((singleRole) => {
        getUserData().userData.role.map((userRole) => {
            if (userRole === singleRole) {
                isAllowed = true;
            }
        })
    })

    return isAllowed;
}

export function isOibValid(input) {
    const oib = input.toString();
    if (oib.match(/\d{11}/) === null) {
        return false;
    }
    return true
}

export const country_list = ["Afghanistan", "Albanija", "Algerija", "Andora", "Angola", "Anguilla", "Antigua &amp; Barbuda", "Argentina", "Armenija", "Aruba", "Australija", "Austrija", "Azerbejdžan", "Bahami", "Bahrain",
    "Bangladeš", "Barbados", "Bjelorusija", "Belgija", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivija", "Bosna i Hercegovina", "Botswana", "Brazil", "Britanski Djevičanski otoci", "Brunei", "Bugarska",
    "Burkina Faso", "Burundi", "Kambodža", "Kamerun", "Cape Verde", "Cayman Islands", "Čad", "Čile", "Kina", "Kolumbija", "Kongo", "Cook Islands", "Kostarika", "Cote D Ivoire", "Hrvatska", "Cruise Ship", "Kuba",
    "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji",
    "Finska", "Francuska", "French Polynesia", "French West Indies", "Gabon", "Gambija", "Georgia", "Njemačka", "Gana", "Gibraltar", "Grčka", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau",
    "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Island", "India", "Indonesia", "Iran", "Irak", "Irska", "Isle of Man", "Izrael", "Italija", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan",
    "Kenya", "Kuwait", "Kyrgyz Republic", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia",
    "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Nizozemska", "Netherlands Antilles",
    "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Papua New Guinea", "Paragvaj", "Peru", "Filipini", "Poland", "Portugal", "Puerto Rico",
    "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre &amp; Miquelon", "Samoa", "San Marino", "Satellite", "Saudijska Arabija", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia",
    "Slovenija", "South Africa", "South Korea", "Spain", "Sri Lanka", "St Kitts &amp; Nevis", "St Lucia", "St Vincent", "St. Lucia", "Sudan", "Suriname", "Swaziland", "Švedska", "Švicarska", "Sirija", "Tajvan",
    "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad &amp; Tobago", "Tunis", "Turska", "Turkmenistan", "Turks &amp; Caicos", "Uganda", "Ukrajna", "United Arab Emirates",
    "Ujedinjeno Kraljevstvo", "Uruguaj", "Uzbekistan", "Venezuela", "Vijetnam", "Virgin Islands (US)", "Jemen", "Zambia", "Zimbabwe"];